// Light Up (Akari) generator & validator
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function computeLit(bulb, wall, n) {
  const lit = Array.from({ length: n }, () => Array(n).fill(false));
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      if (!bulb[r][c]) continue;
      lit[r][c] = true;
      for (const [dr, dc] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
        let nr = r + dr, nc = c + dc;
        while (nr >= 0 && nc >= 0 && nr < n && nc < n && !wall[nr][nc]) {
          lit[nr][nc] = true;
          nr += dr; nc += dc;
        }
      }
    }
  return lit;
}

function countAdjBulbs(bulb, r, c, n) {
  let k = 0;
  for (const [dr, dc] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
    const nr = r + dr, nc = c + dc;
    if (nr >= 0 && nc >= 0 && nr < n && nc < n && bulb[nr][nc]) k++;
  }
  return k;
}

export function makeAkari(n, wallRatio = 0.2) {
  const wall = Array.from({ length: n }, () => Array(n).fill(false));
  const target = Math.floor(n * n * wallRatio);
  let cnt = 0;
  for (const idx of shuffle([...Array(n * n).keys()])) {
    if (cnt >= target) break;
    wall[Math.floor(idx / n)][idx % n] = true;
    cnt++;
  }
  const bulb = Array.from({ length: n }, () => Array(n).fill(false));
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      if (wall[r][c]) continue;
      const lit = computeLit(bulb, wall, n);
      if (!lit[r][c]) bulb[r][c] = true;
    }
  const number = Array.from({ length: n }, () => Array(n).fill(null));
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++)
      if (wall[r][c] && Math.random() < 0.55) number[r][c] = countAdjBulbs(bulb, r, c, n);
  return { n, wall, number, solution: bulb };
}

export { computeLit, countAdjBulbs };

export function akariConflicts(bulb, wall, n) {
  const bad = new Set();
  // two bulbs seeing each other (same segment)
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      if (!bulb[r][c]) continue;
      for (const [dr, dc] of [[1, 0], [0, 1]]) {
        let nr = r + dr, nc = c + dc;
        while (nr >= 0 && nc >= 0 && nr < n && nc < n && !wall[nr][nc]) {
          if (bulb[nr][nc]) { bad.add(`${r},${c}`); bad.add(`${nr},${nc}`); }
          nr += dr; nc += dc;
        }
      }
    }
  return bad;
}

export function akariWin(bulb, wall, number, n) {
  const lit = computeLit(bulb, wall, n);
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      if (wall[r][c]) {
        if (number[r][c] != null && countAdjBulbs(bulb, r, c, n) !== number[r][c]) return false;
      } else if (!lit[r][c]) return false;
    }
  return akariConflicts(bulb, wall, n).size === 0;
}
